<boi-contextual-help-container [ngClass]="{'has-errors': hasError}"
    [contextualHelpName]="contextualHelpName !== undefined ? contextualHelpName : labelName">

    <boi-validation-error (errorChange)="hasError=$event" [propertyNames]="propertyNames"></boi-validation-error>

    <kendo-textbox-container class="form-element app {{cssClasses}}">
        <div class="form-label app" [boiRequiredFormField]="labelName" [forceRequired]="forceRequired">
            <label [for]="controlId ? controlId : labelName" [innerHtml]="labelName |
            localizeLabel: labelIndex"></label>
        </div>

        <div class="form-input-container">

            <kendo-numerictextbox [ngClass]="{'currency':isCurrency, 'disabled': isFieldDisabled}"
                [disabled]="isFieldDisabled" [id]="controlId ? controlId : labelName" spinners="false" [step]="0"
                [(ngModel)]="numericValue" (keypress)="checkInputLength($event)" [format]="getNumberOfDecimalsFormat()"
                (blur)="resetFieldIfLessThanMinValue(); blurChange.emit(value)" [min]="fieldMinValue" [decimals]="decimals ? decimals : 0"
                [max]="fieldMaxValue" (ngModelChange)="valueChange.emit(value)">
            </kendo-numerictextbox>
        </div>
        <ng-content></ng-content>

        <boi-tooltip [tooltipPosition]="tooltipPosition" [tooltipName]="tooltipName ? tooltipName : labelName">
        </boi-tooltip>

    </kendo-textbox-container>
</boi-contextual-help-container>